<template>
    <v-dialog
        v-model    = "value"
        transition = "dialog-bottom-transition"
        fullscreen
        hide-overlay
        persistent
        no-click-animation
    >
        <div class="white" style="margin-top: 6px; width: calc(100% - 65px); ">
            <f-dialog-title
                title   = "INBOX"
                @cancel = "onCancel"
                style   = "border-radius: 4px;margin-left: 75px;"
            />

            <div class="mt-2 content">
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-1">
                        <div class="w-100 v-flex" style="height: 30px;">
                            <div class="folder-tab v-tab folder-tab-active primary" style="border-bottom-width: 1px">Mail / Anhang</div>
                        </div>

                        <div class="w-100 white mt-1" style="height: calc(100% - 35px)">
                            <c-dms-viewer
                                :document = "document"
                            />
                        </div>
                    </v-col>
                    <v-col class="no-frame col-6 pl-1">
                        <div class="w-100 v-flex">
                            <div class="folder-tab v-tab folder-tab-active primary" style="border-bottom-width: 1px">Inhalt</div>
                            <v-spacer />
                            <c-inbox-attachment-menu
                                :attachment   = "attachment"
                                :zoom-allowed = "false"
                                @save         = "onSave"
                                @close        = "onClose"
                                @create       = "onCreate"
                                @creategoto   = "onCreateAndGoto"
                            />
                        </div>

                        <c-inbox-detail
                            :attachment = "attachment"
                            :height     = "height-30"
                            @changed    = "onChanged"
                            @context    = "onContext"
                            @morph      = "onMorph"
                            ref         = "message"
                            class       = "mt-1"
                        />
                    </v-col>
                </v-row>
            </div>
        </div>
    </v-dialog>
</template>

<script>

import FDialogTitle from "@/modules/core/components/utils/FDialogTitle";
import CInboxDetail from "@/modules/inb/components/main/details/CInboxDetail";
import CInboxAttachmentMenu from "@/modules/inb/components/controlls/CInboxAttachmentMenu";
import CDmsViewer from "@/modules/dms/viewer/CDmsViewer.vue";

export default {
    name: "DInboxDetail",
    components: {
        CDmsViewer,
        CInboxAttachmentMenu,
        CInboxDetail,
        FDialogTitle
    },

    props: {
        value: {},
        attachment: {

        },

        height: {

        },
    },

    data: () => ({
        site: null,
        refresh: 0,
        document: null
    }),

    watch: {
        value () {
            if (this.value) {
                if (this.attachment.duplicate) {
                    this.document = this.attachment.duplicate.dmsId;
                } else {
                    this.document = this.attachment.dmsId;
                }
            }
        },
    },

    methods: {
        onSave (success) {
            this.$refs.message.save (success);
        },

        onMorph (event) {
            this.$emit("morph", event);
        },

        onCancel () {
            this.$emit("input", false);
        },

        onClose () {
            this.$emit("input", false);
            this.$emit("close");
        },

        onContext (item) {
            this.$emit("context", item);
        },

        onChanged (item) {
            this.$emit("changed", item);
        },

        onCreate () {
            this.$emit("create");
        },

        onCreateAndGoto () {
            this.$emit("input", false);
            this.$emit("creategoto");
        },
    }
}
</script>

<style scoped>

.content {
    margin-left: 75px;
    height: calc(100% - 30px);
    width: calc(100% - 75px);
}

</style>